var TscThemeName = {
  dawn: 'dawn',
  dusk: 'dusk'
};
export default TscThemeName; // remove this after sufficient time and versions (JMD: 2022-04)

/**
 * @deprecated The use default TscThemeName instead
 */

export { TscThemeName as themeNames };